export default function IconArrowLeft({ className }: { className?: string }) {
    return (
        <svg
            className={className}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14 26L15.41 24.59L7.83 17H28V15H7.83L15.41 7.41L14 6L4 16L14 26Z"
                fill="currentColor"
            />
        </svg>
    )
}
